import { spawn } from 'redux-saga/effects';
import { sagas as listzoneSagas } from './listzonesModule';

export default function* sagas() {
	yield spawn(listzoneSagas);
}
